import { IonContent, IonPage, IonButton, IonHeader, IonToolbar, IonToast, IonLoading,
  IonIcon, IonText, IonRow, IonGrid, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';

import React, { useState, useRef, useEffect } from 'react';
import { RouteComponentProps, useLocation} from "react-router-dom";
import { Map } from "../../components/Explore/Map";
import {set,get} from '../../services/storage.service';
import { usePhotoGallery } from '../../hooks/usePhotoGallery';

import { useHistory } from "react-router-dom";
import { remove } from '../../services/storage.service';
import FooterComponent from "../../components/FooterComponent";
import LoginCheck from "../../components/LoginCheck";
import { logOutOutline, chevronBackOutline, manSharp } from 'ionicons/icons';
import { getAllByTestId } from '@testing-library/react';

export interface Photo {
  filepath: string;
  webviewPath?: string;
}

interface ResetProps
    extends RouteComponentProps<{
        color: string,
        name: string;
    }> { }

    interface LocationError {
      showError: boolean;
      message?: string;
  }
const EditMarkers: React.FC<ResetProps> = ({ match }) => {

const projtitle = match.params.name;
const colorpin = match.params.color;

  const history = useHistory();
  function logOut(){
    //console.log("logout");
    remove('cred');
    history.push('/home');
  }
  var uniqueID = Math.random().toString(36).substr(2, 9);
  const markersDefault = [
      {pos: [43.073051,-89.401230], title: '', description: '', id: uniqueID, filepath: "", webview: "", color: colorpin}
  ];
  const selected = [
    0
  ];
  const myfields = 0;

  
  //end markers drag
  //var location: [number,number][] = [
    //[43.073051, -89.401230],
  //]
   //end markers drag
   var location: [number,number] = [
    43.073051, -89.401230
  ]

  const [group, setGroup] = useState<string>('Group 1');
  const [error, setError] = useState<LocationError>({ showError: false });
  const [loading, setLoading] = useState<boolean>(false);
  const [groupcolor,setGroupColor] = useState<string>(match.params.color);
  const [markers, setMarkers] = useState<any>(markersDefault);
  const [markertotal,setTotal] = useState<any>(1);
  const [mapCenter, setCenter] = useState<any>(location);
  const [loadedPhotos, setPhotos] = useState<any>([]);
  const [openLatest,setLatest] = useState<any>();

  const loadPhotos = async () => {
   await get('photos')
    .then(function (photoString) {
      if(photoString !== null){
        setPhotos(photoString);
        console.log("photoString",photoString);
      }else{
        console.log("photoString null");
      }
      
      //console.log(loadedPhotos);
    }).catch(err => {//unable to load the local storage
      console.log("e: " + err.message);
    }
    );
    
  }
 
  //get the location on load
 
  useIonViewDidEnter(() => {
    setGroupColor(colorpin);
    console.log("willenter - title:",projtitle);
 
    //load in the saved data on page load - this is not firing every time
    var savetitle = projtitle.replace(/ /g,"_");
    console.log("savetitle",savetitle);
    console.log(projtitle);

    get(savetitle)
    .then(function (finalResult) { //get the user data to authenticate the user
      console.log("running...");
      //setShowLoading(true);
      const loadedMarkers = JSON.parse(finalResult);
      setMarkers(loadedMarkers.markers);
      console.log();

    }).catch(err => {//unable to load the local storage
      console.log("e: " + err.message);
    }
    );
    console.log("saved photos");
    loadPhotos();
  });
 function loadMarkers(){
  var savetitle = match.params.name.replace(/ /g,"_");
  console.log("savetitle",savetitle);
  console.log(match.params.name);

  get(savetitle)
  .then(function (finalResult) { //get the user data to authenticate the user
    console.log("running...");
    //setShowLoading(true);
    const loadedMarkers = JSON.parse(finalResult);
    setMarkers(loadedMarkers.markers);
    console.log();
  }).catch(err => {//unable to load the local storage
    console.log("e: " + err.message);
  }
  );
  console.log("saved photos");
  loadPhotos();
 }

  function addMarker(e:any,d:any,c:any,b:any,a:any){ //,c:any
    var uniqueID = Math.random().toString(36).substr(2, 9);
    setMarkers([...markers,{pos:[e,d],title:c,description:b,id:uniqueID,photoID:a}]);
    setTotal(markers.length+1);//always have it be 2 or more
    console.log('now select the new marker');
    setLatest({e,d,uniqueID});
    
  }

  function removeFromArray(id:any){ //delete the marker from the mix

    for(var i = 0; i <= markers.length - 1; i++){
      if(markers[i]['id'] === id){
          //setMarkers([markers.splice(i,1)]);
          /*setMarkers([
          ...markers.slice(0,i-1),
          ...markers.slice(i,markers.length-1)
          ]);*/
          const newTodos = [...markers];
          newTodos.splice(i,1);
          setMarkers(newTodos);
          console.log("found: " + id + " : " +  i);
      }
    }
  }
  function setMapCenter(lat:any, long:any){
    setCenter([lat,long]);
  }
  function updateMarkers(e:any){
      if(e !== ""){
        setMarkers(e);
      }
  }
  //update the coordinates on drag
  function updatePosition(lat:any,lng:any,id:any){
    console.log("new coordinates for: " + id);
    for(var i = 0; i <= markers.length - 1; i++){
      if(markers[i]['id'] === id){//update the values in that array 
          const newTodos = [...markers];
          newTodos[i]['pos'][0] = lat;
          newTodos[i]['pos'][1] = lng;
          setMarkers(newTodos);
      }
    }
  }
  //update the popup title, description, photo*
  function updateContent(title:string,description:string,id:any,group:any,fileid:any,webid:any,gallery:any,color:any){
    setLoading(true);
    var savetitle = group.replace(/ /g,"_");
    console.log('gallery',gallery);
    console.log("update me",savetitle,"fileid", fileid, "webid",webid);
    for(var i = 0; i <= markers.length - 1; i++){
      if(markers[i]['id'] === id){//update the values in that array 
          const newTodos = [...markers];
          console.log(newTodos);
          newTodos[i]['title'] = title;
          newTodos[i]['description'] = description;
          newTodos[i]['fileid'] = fileid;
          newTodos[i]['webid'] = webid;
          newTodos[i]['gallery'] = gallery;//save the whole gdang photos array here.
          newTodos[i]['color'] = color;
          setMarkers(newTodos);
          console.log(markers);
      }
    }
    //save the array to the local save.
    set(savetitle, JSON.stringify({markers}))
    .then(function (finalResult) { //get the user data to authenticate the user
      console.log("saved");
      setLoading(false);
      setError({ showError: true, message: "Your marker settings have been saved." });
      setLoading(false);
      //reload page

      //window.location.reload();
      //Map.forceUpdate();
      //this.setState({ state: this.state });
      console.log('remoter')
    }).catch(err => {//unable to load the local storage
      console.log("e: " + err.message);
    }
    );
    
  }

  //debug stuff
  useEffect(() => {
    console.log(markers);
    console.log("markers update");
  }, [markers]);
  useEffect(() => {
    console.log(group);
  }, [group]);
  useEffect(() => {
    console.log("center updated",mapCenter);
  }, [mapCenter]);
  

    return (
      <>
      <IonToast
          isOpen={error.showError}
          onDidDismiss={() => setError({ message: "", showError: false })}
          position={'middle'}
          message={error.message}
          duration={3000}
      />
      <IonLoading
          isOpen={loading}
          onDidDismiss={() => setLoading(false)}
          message={'Saving Markers...'}
      />
      <IonPage>
      <LoginCheck/>
        <IonHeader translucent={true} >
        <IonToolbar>
        <IonButton size="small" slot="start" color="primary" onClick={() => history.replace("/createexploration/")} className="back"><IonIcon slot="start" icon={chevronBackOutline}/>Back</IonButton>
        <IonButton size="small" slot="end" color="primary" onClick={() => logOut()}  className="logout"><IonIcon slot="end" icon={logOutOutline}/>Log Out</IonButton>
        </IonToolbar>
      </IonHeader>
      
          <IonContent className="ion-text-center maintext headerimage">
            <IonText className="plantext innertext">
      <span>[</span>  <h3>Explore</h3> <span>]</span><h5>Add Markers</h5></IonText>
              <IonGrid className="grid">
              <IonRow>
                  <Map
                      listOfMarkers={markers}
                      photoGroup={loadedPhotos}
                      markergroup={match.params.name}
                      markercolor={match.params.color}
                      addMarker={addMarker}
                      markertotal={markertotal}
                      loadMarkers={loadMarkers}
                      mapCenter={mapCenter}
                      removeFromArray={removeFromArray}
                      updatePosition={updatePosition}
                      updateContent={updateContent}
                      updateMarkers={updateMarkers}
                      setMapCenter={setMapCenter}
                      openLatest={openLatest}
                  />
              </IonRow>
              </IonGrid>
        </IonContent>
      
        <FooterComponent/>
      </IonPage>
      </>
    );
  };


export default EditMarkers;